import { Controller } from 'stimulus';

// Public-facing form: hides/shows entire sections based on conditional rules.
// Each section element with a data-parent-field-id is conditional.
export default class extends Controller {
  static targets = ['section'];

  connect() {
    this.handler = () => this.evaluateAll();
    this.element.querySelectorAll('select, input[type="radio"], input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', this.handler);
    });
    this.evaluateAll();
  }

  evaluateAll() {
    this.sectionTargets.forEach((sectionEl) => {
      const parentFieldId = sectionEl.dataset.parentFieldId;
      if (!parentFieldId) return;

      const conditionValues = JSON.parse(sectionEl.dataset.conditionValues || '[]');
      const parentValues = this.findParentValues(parentFieldId);
      const conditionMet = conditionValues.some(cv => parentValues.includes(cv));

      if (conditionMet) {
        this.showSection(sectionEl);
      } else {
        this.hideSection(sectionEl);
      }
    });
  }

  findParentValues(parentFieldId) {
    const wrapper = this.element.querySelector(`[data-field-id="${parentFieldId}"]`);
    if (!wrapper) return [];

    const values = [];
    const select = wrapper.querySelector('select');
    if (select && select.value) values.push(select.value);

    const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
    if (checkedRadio) values.push(checkedRadio.value);

    wrapper.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => {
      if (cb.value) values.push(cb.value);
    });

    return values;
  }

  showSection(sectionEl) {
    sectionEl.classList.remove('hidden');
    sectionEl.querySelectorAll('[data-field-id]').forEach((fieldEl) => {
      const isRequired = fieldEl.dataset.fieldRequired === 'true';

      fieldEl.querySelectorAll('input, select, textarea').forEach((input) => {
        if (input.type === 'hidden') return;
        input.removeAttribute('disabled');
      });

      if (isRequired) {
        const primary = fieldEl.querySelector('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), select, textarea');
        if (primary) primary.setAttribute('required', 'required');
        fieldEl.querySelectorAll('input[type="radio"]').forEach(r => r.setAttribute('required', 'required'));
      }
    });
  }

  hideSection(sectionEl) {
    sectionEl.classList.add('hidden');
    sectionEl.querySelectorAll('input, select, textarea').forEach((input) => {
      if (input.type === 'hidden') return;
      input.setAttribute('disabled', 'disabled');
      input.removeAttribute('required');
    });
  }
}
